import { format } from 'date-fns'
import React, { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { Link, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { getInquiries } from '../../api/inquiries'
import { ReplyRounded } from '../../components/Badge'
import { Button } from '../../components/Button'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import { useAppContext } from '../../components/provider/AppProvider'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/myshopping.css'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'
import { CartTotalPayment } from '../cart/CartList'

// 이미지 경로
const imgURL = '/images'

export default function InquiryList() {
  const [inquiriesData, setInquiriesData] = useState<any>(null)
  const [count, setCount] = useState<number[]>([])
  const [page, setPage] = useState<number>(1)
  const [checkLoading, setCheckLoading] = useState<boolean>(false)

  const { isAppView } = useAppContext()
  const { setIsLottie } = useCommonContext()

  const navigate = useNavigate()

  useEffect(() => {
    getInquiries({ pageNumber: page, pageSize: 10 })
      .then((res) => {
        setInquiriesData(res)
        const pageCount = Math.floor(res.data.items.length / 10) === 0 ? 1 : Math.floor(res.data.items.length / 10) + 1
        for (let i = 0; i < pageCount; i++) {
          setCount((prev) => [...prev, i + 1])
        }
        setIsLottie(false)
        setCheckLoading(true)
      })
      .catch((err) => console.log(err))
  }, [])

  useEffect(() => {
    if (checkLoading) {
      getInquiries({ pageNumber: page, pageSize: 10 }).then((res: any) => {
        setInquiriesData(res)
        setIsLottie(false)
      })
    }
  }, [page])

  // 1:1 문의가 없을 때 박스 높이 조절
  useEffect(() => {
    const contentsWrap = document.querySelector('.contents_wrap') as HTMLElement

    inquiriesData?.data.items.length === 0
      ? contentsWrap?.classList.add('full')
      : contentsWrap?.classList.remove('full')
  }, [inquiriesData])

  useEffect(() => {
    // 하단 fixed버튼이 있다면 푸터를 밀어내야함
    const footer = document.querySelector('.footer_wrap') as HTMLElement
    if (footer) {
      isMobile
        ? inquiriesData !== null && inquiriesData.data.items.length !== 0
          ? (footer.style.paddingBottom = '108px')
          : (footer.style.paddingBottom = '36px')
        : (footer.style.paddingBottom = '0')
    }
  }, [inquiriesData])

  return (
    <>
      <div className='main_wrap'>
        <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap full'}>
          <MyShoppingSideBar />
          <div className='myshopping_wrap'>
            <PageTitle>1:1 문의</PageTitle>
            {!isMobile && inquiriesData !== null && inquiriesData.data.items.length > 0 ? (
              <BtnInquiryWrite
                onClick={() => {
                  if (isAppView) {
                    RNPostMessage(AFWebLinkType.moveToLink, {
                      url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/inquiryWrite`,
                    })
                  } else {
                    navigate('/inquiryWrite')
                  }
                }}
              >
                문의하기
              </BtnInquiryWrite>
            ) : null}
            {inquiriesData !== null && inquiriesData.data.items.length > 0 ? (
              <div className='inquiry_list'>
                <ul>
                  {inquiriesData.data.items.map((el: any, index: number) => (
                    <li
                      onClick={() => {
                        if (isAppView) {
                          RNPostMessage(AFWebLinkType.moveToLink, {
                            url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/inquiryView?id=${el.inquiryNo}`,
                          })
                        } else {
                          navigate(`/inquiryView?id=${el.inquiryNo}`)
                        }
                      }}
                      key={`${index}1`}
                    >
                      <Link to='#'>
                        <div>
                          <div className='part'>{el.inquiryType.inquiryTypeName}</div>
                          <div className='title'>{el.inquiryTitle}</div>

                          <div className='status_date'>
                            {el.inquiryStatus === 'ANSWERED' ? (
                              <ReplyRounded style={{ color: 'black' }} isreply='false'>
                                답변완료
                              </ReplyRounded>
                            ) : (
                              <ReplyRounded isreply='false'>답변대기</ReplyRounded>
                            )}
                            <span className='date'>
                              {((): any => {
                                const date = new Date(el.registerYmdt)
                                return format(date, 'yyyy. M. d')
                              })()}
                            </span>
                          </div>
                        </div>
                        <span>
                          <img src={`${imgURL}/icon_arrow_right_black.png`} alt='' />
                        </span>
                      </Link>
                    </li>
                  ))}
                </ul>

                {/* 페이지네이션 */}
                {count.length === 1 || count.length === 0 ? null : (
                  <div className='pagination'>
                    <button>
                      <img src={`${imgURL}/icon_arrow_prev.svg`} alt='' />
                    </button>
                    {count.map((el) => {
                      return (
                        <button
                          className={page === el ? 'on' : ''}
                          onClick={() => {
                            setPage(el)
                            if (el !== 1) {
                              setIsLottie(true)
                            }
                          }}
                          key={el}
                        >
                          {el}
                        </button>
                      )
                    })}
                    <button>
                      <img src={`${imgURL}/icon_arrow_next.svg`} alt='' />
                    </button>
                  </div>
                )}
              </div>
            ) : (
              // 목록 없을 때
              <div className='inquiry_list'>
                <div className='no_data'>
                  <p>1:1 문의가 없습니다.</p>
                  <NoContentBtn
                    onClick={() => {
                      navigate('/inquiryWrite')
                    }}
                  >
                    문의하기
                  </NoContentBtn>
                </div>
              </div>
            )}
            {isMobile && inquiriesData !== null && inquiriesData.data.items.length > 0 && (
              <CartTotalPayment className='btn_fixed'>
                <BtnInquiryWrite
                  onClick={() => {
                    navigate('/inquiryWrite')
                  }}
                >
                  문의하기
                </BtnInquiryWrite>
              </CartTotalPayment>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
export const NoContentBtn = styled(Button)`
  display: inline-block;
  font-size: 15px;
  font-weight: 600;
  padding: 12px 35px;
  color: var(--colWhite);
  background: var(--colBlack);
  border-radius: 76px;
  line-height: 20px;
  margin-top: 20px;
  @media screen and (min-width: 768px) {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    padding: 14px 40px;
    margin-top: 32px;
    cursor: pointer;
  }
`
export const BtnInquiryWrite = styled(Button)`
  bottom: 0;
  left: 0;
  width: 100%;
  height: 48px;
  background: var(--colBlack);
  color: var(--colWhite);
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  border-radius: 5px;
  @media screen and (min-width: 768px) {
    position: absolute;
    top: 24px;
    left: unset;
    right: 0;
    width: 120px;
    height: 48px;
  }
`
